module.exports = __webpack_public_path__ + "assets/plus_grey-762540.svg";